<div class="w-full min-h-screen bg-white p-3 md:p-5">
  <p-toast></p-toast>

  <div class="flex flex-column md:flex-row justify-content-between align-items-center gap-3 mb-5">
    <div>
      <h2 class="m-0 text-900">Club / Newsletter</h2>
      <p class="m-0 mt-2 text-500 text-sm">Suscriptores con opt-in. Búsqueda por correo u origen.</p>
    </div>
    <span class="p-input-icon-left w-full md:w-auto">
      <input pInputText type="text" [(ngModel)]="search" (input)="scheduleServerLoad()"
             placeholder="Buscar correo u origen..."
             class="w-full md:w-20rem border-round-3xl input-search" />
    </span>
  </div>

  <p-table [value]="list" [lazy]="true" (onLazyLoad)="load($event)"
           [first]="first" [rows]="rows" [totalRecords]="totalRecords"
           [paginator]="true" [loading]="loading"
           [rowsPerPageOptions]="[10, 25, 50]"
           [tableStyle]="{ 'min-width': '40rem' }"
           [rowHover]="true"
           styleClass="p-datatable-sm">
    <ng-template pTemplate="header">
      <tr class="uppercase text-xs text-500">
        <th>Correo</th>
        <th class="text-center">Opt-in</th>
        <th class="text-center">Origen</th>
        <th class="text-center">Fecha</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr class="text-sm">
        <td class="font-bold text-900">{{ row.email }}</td>
        <td class="text-center">
          <span [class]="'text-xs font-bold px-2 py-1 border-round ' + (row.optedIn ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700')">
            {{ row.optedIn ? 'SÍ' : 'NO' }}
          </span>
        </td>
        <td class="text-center uppercase text-xs">{{ row.source || '—' }}</td>
        <td class="text-center">{{ row.createdAt | date:'dd/MM/yyyy HH:mm' }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center text-500 py-5">Aún no hay suscriptores.</td>
      </tr>
    </ng-template>
  </p-table>
</div>